import React from "react";
import { useTranslation } from "react-i18next";
import FeedbackModal from "../feedback/FeedbackModal";

const SubscribePluginModal = ({ show, onHide, onSubscribe }) => {
  const { t } = useTranslation();

  return (
    <FeedbackModal
      show={show}
      onHide={onHide}
      severity="info"
      title={t("subscribePluginModal.title")}
      message={t("subscribePluginModal.disclaimer")}
      secondaryAction={{
        label: t("subscribePluginModal.cancel"),
        onClick: () => onHide && onHide(),
      }}
      primaryAction={{
        label: t("subscribePluginModal.subscribe"),
        onClick: () => onSubscribe && onSubscribe(),
      }}
    />
  );
};

export default SubscribePluginModal;
